var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDropbox = function SvgDropbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0061FE",
    fillRule: "evenodd",
    d: "M18 4 4 13.882l14 9.883-14 9.882 14 9.882 14-9.882 14 9.882 14-9.882-14-9.882 14-9.883L46 4l-14 9.882L18 4Zm14 9.882 14 9.883-14 9.882-14-9.882 14-9.883Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0061FE",
    d: "m18 50.118 14-9.883 14 9.883L32 60l-14-9.882Z"
  })));
};
export { SvgDropbox as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOCA0TDQgMTMuODgyNEwxOCAyMy43NjQ3TDQgMzMuNjQ3MUwxOCA0My41Mjk0TDMyIDMzLjY0NzFMNDYgNDMuNTI5NEw2MCAzMy42NDcxTDQ2IDIzLjc2NDdMNjAgMTMuODgyNEw0NiA0TDMyIDEzLjg4MjRMMTggNFpNMzIgMTMuODgyNEw0NiAyMy43NjQ3TDMyIDMzLjY0NzFMMTggMjMuNzY0N0wzMiAxMy44ODI0WiIgZmlsbD0iIzAwNjFGRSIvPgo8cGF0aCBkPSJNMTggNTAuMTE3NkwzMiA0MC4yMzUzTDQ2IDUwLjExNzZMMzIgNjBMMTggNTAuMTE3NloiIGZpbGw9IiMwMDYxRkUiLz4KPC9zdmc+Cg==";